import type { Directive, DirectiveBinding } from 'vue';

export const visibleDirective: Directive<HTMLElement, DirectiveBinding> = (
  el: HTMLElement,
  binding: DirectiveBinding
) => {
  el.style.visibility = binding.value ? 'visible' : 'hidden';
};
